<template lang="pug">
#MonitoramentoSocioambiental
    el-card.mb-4.box-card(
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        el-collapse
            el-collapse-item(name='filtro')
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-filter-variant.mr-2(style='font-size: 20px')
                        | Filtros

                el-form.row.m-0.px-2(label-position='top', size='mini')
                    el-form-item.col-5.p-0
                        label.mb-0 Empresa
                        el-select(
                            v-model='filtro.empresasIds',
                            style='width: 100%',
                            placeholder='Selecione',
                            multiple,
                            value-key='id'
                        )
                            el-option.titulo-empresas(
                                v-for='empresa in empresas',
                                :key='empresa.id',
                                :label='captalize(empresa.name)',
                                :value='empresa.id'
                            )

                    el-form-item.col-1.p-0

                    el-form-item.col-6.p-0
                        label.mb-0 Usuário
                        el-select(
                            v-model='filtro.usuariosIds',
                            style='width: 100%',
                            filterable,
                            remote,
                            multiple,
                            reserve-keyword,
                            :remote-method='remoteMethodUsuario',
                            @blur='buscarUsuarios'
                        )
                            el-option(
                                v-for='usuario in usuarioBusca',
                                :key='`${usuario.nome}${usuario.id}`',
                                :label='captalize(usuario.name)',
                                :value='usuario.id'
                            )
                                | {{ usuario.name }}

                    el-form-item.col-6.p-0
                        label.mb-0 Data requisição
                        .d-flex
                            el-date-picker(
                                v-model='filtro.dataRequisicaoInicio',
                                placement='bottom-start',
                                type='date',
                                placeholder='Selecione',
                                format='dd/MM/yyyy'
                            )
                            span.mx-3 à
                            el-date-picker(
                                v-model='filtro.dataRequisicaoFim',
                                placement='bottom-start',
                                type='date',
                                placeholder='Selecione',
                                format='dd/MM/yyyy'
                            )

                    el-form-item.col-4.p-0
                        label.mb-0 Registros Inativos
                        .d-flex
                            el-checkbox(
                                v-model='filtro.registrosInativos',
                                label='true'
                            ) Exibir registros inativos

                    el-form-item.col-2.p-0.align-items-end.d-flex.justify-content-end
                        el-button(icon='el-icon-delete', @click='limparFiltro') Limpar
                        el-button(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='buscarDados'
                        ) Filtrar

    el-card.mb-4.box-card(
        v-if='hasMonitoramento && hasDadosGrafico',
        shadow='never'
    )
        .grafico-box
            .grafico-direito
                ChartLine.chart-height(
                    chartId='monitoramentoLineId',
                    :chartData='chartMonitoramento.chartData',
                    :chart-options='chartMonitoramento.chartOptions',
                    :styles='chartStyles'
                )

            .grafico-esquerdo
                ChartLine.chart-height(
                    chartId='areaMonitoradaLineId',
                    :chartData='chartAreaMonitorada.chartData',
                    :chart-options='chartAreaMonitorada.chartOptions',
                    :styles='chartStyles'
                )

    el-card.box-card(
        v-if='hasMonitoramento',
        shadow='never',
        :body-style='{ padding: "10px" }',
        style='margin: 20px'
    )
        el-table.px-2(:data='monitoramentos', size='mini')
            el-table-column(label='Nome usuário', prop='nomeUsuario', sortable)
            el-table-column(label='Empresa', prop='nomeEmpresa', sortable)
            el-table-column(
                label='Data envio',
                prop='dataCadastroFormatada',
                sortable
            )
            el-table-column(label='Área (ha)', sortable)
                template(slot-scope='scope')
                    div {{ getArea(scope.row.areaHa) }}

            el-table-column(
                label='Código Vega API',
                prop='codigoVegaAPI',
                sortable
            )

        .mt-4.px-2.justify-content-between.d-flex.align-items-center
            el-button(
                type='primary',
                icon='el-icon-document',
                @click='exportarDadosMonitoramentos()',
                size='mini'
            ) Exportar Dados
            el-pagination(
                background,
                :page-size='pageParams.size',
                :current-page.sync='pageParams.page',
                layout='prev, pager, next',
                :total='totalMonitoramentos',
                @current-change='buscarMonitoramentos'
            )
            div
                label.label-soma {{ `Σ Total de registros: ${totalMonitoramentos}` }}
                label.label-soma.pl-5
                    i.el-icon-crop
                    | {{ ` Área total (ha): ${getArea(totalAreas)}` }}
</template>

<script>
import ChartLine from '@/components/charts/GraficoLine';
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import UsuarioService from '@/services/UsuarioService';

import formatters from '@/utils/formatters';
import { isEqual } from 'lodash';

const ordem = (a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
    }
    return 0;
};

export default {
    name: 'MonitoramentoSocioambiental',
    components: {
        ChartLine
    },

    emits: ['buscar_empresas'],

    props: {
        empresas: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    computed: {
        hasMonitoramento() {
            return this.monitoramentos && this.monitoramentos.length > 0;
        },

        hasDadosGrafico() {
            return (
                this.dadosGrafico.monitoramento &&
                this.dadosGrafico.areaMonitorada
            );
        }
    },

    data() {
        return {
            chartMonitoramento: {
                chartData: {
                    labels: [],
                    datasets: []
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        title: {
                            display: true,
                            text: 'Monitoramento Socioambiental',
                            font: {
                                size: 18
                            }
                        }
                    }
                }
            },
            chartAreaMonitorada: {
                chartData: {
                    labels: [],
                    datasets: []
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        title: {
                            display: true,
                            text: 'Área Monitorada',
                            font: {
                                size: 18
                            }
                        }
                    }
                }
            },
            chartStyles: {
                height: '300px',
                position: 'relative'
            },

            filtro: {
                empresasIds: [],
                usuariosIds: [],
                dataRequisicaoInicio: null,
                dataRequisicaoFim: null,
                registrosInativos: false
            },
            monitoramentos: [],
            dadosGrafico: [],
            pageParams: {
                page: 1,
                size: 50,
                sort: 'data_cadastro,DESC'
            },
            totalMonitoramentos: 0,
            totalAreas: 0,
            usuarioBusca: [],
            listaUsuarios: []
        };
    },

    created() {
        this.buscarUsuarios();
    },

    mounted() {
        this.buscarDados();
    },

    methods: {
        getArea(area) {
            return formatters.formatNumber(area, 2);
        },
        remoteMethodUsuario(query) {
            if (query !== '') {
                this.usuarioBusca = this.listaUsuarios.filter(item => {
                    return (
                        item.name.toLowerCase().indexOf(query.toLowerCase()) >
                        -1
                    );
                });
            } else {
                this.usuarioBusca = this.listaUsuarios;
            }
        },

        async buscarUsuarios() {
            if (this.listaUsuarios.length) return;
            UsuarioService.buscaTodosSemPaginacao('')
                .then(({ data }) => {
                    this.listaUsuarios = data.sort(ordem);
                    this.usuarioBusca = this.listaUsuarios;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error
                    });
                });
        },

        buscarDados() {
            this.buscarMonitoramentos();
            this.buscarDadosGrafico();
        },

        async buscarMonitoramentos() {
            try {
                const { data } =
                    await MonitoramentoSocioambientalService.consultaRelatorio(
                        this.filtro,
                        this.pageParams
                    );

                this.totalMonitoramentos = data.totalItens;
                this.monitoramentos = data.areasMonitoradas;
                this.totalAreas = 0;
                this.totalAreas = data.areasMonitoradas
                    .map(monitorada => monitorada.areaHa)
                    .reduce(
                        (accumulator, currentValue) =>
                            accumulator + currentValue,
                        this.totalAreas
                    );
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possivel carregar os dados de monitoramento.'
                });
            }
        },

        async buscarDadosGrafico() {
            try {
                const { data } =
                    await MonitoramentoSocioambientalService.buscarRelatorioGrafico(
                        this.filtro
                    );
                this.dadosGrafico = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possivel carregar os dados do gráfico.'
                });
            }

            if (this.dadosGrafico.monitoramento) {
                this.chartMonitoramento.chartData.labels = [
                    ...new Set(this.dadosGrafico.monitoramento.labels)
                ];
                this.chartMonitoramento.chartData.datasets = [
                    ...new Set(this.dadosGrafico.monitoramento.datasets)
                ];
            }
            if (this.dadosGrafico.areaMonitorada) {
                this.chartAreaMonitorada.chartData.labels = [
                    ...new Set(this.dadosGrafico.areaMonitorada.labels)
                ];
                this.chartAreaMonitorada.chartData.datasets = [
                    ...new Set(this.dadosGrafico.areaMonitorada.datasets)
                ];
            }
        },

        captalize(empresa) {
            const nomeEmpresa = empresa.toLowerCase().replaceAll('_', ' ');
            return nomeEmpresa.replace(/(?:^|\s)\S/g, a => a.toUpperCase());
        },

        exportarDadosMonitoramentos() {
            MonitoramentoSocioambientalService.exportarRelatorio(this.filtro)
                .then(() => {
                    this.$notify.success({
                        message: 'Exportação realizada com sucesso!'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao realizar a exportação!'
                    });
                });
        },

        limparFiltro() {
            const filtroCopy = this.filtro;
            this.filtro = {
                empresasIds: [],
                usuariosIds: [],
                dataRequisicaoInicio: null,
                dataRequisicaoFim: null,
                registrosInativos: false
            };

            if (!isEqual(filtroCopy, this.filtro)) {
                this.buscarDados();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#MonitoramentoSocioambiental {
    .el-collapse-item__content {
        padding: 0;
    }

    .el-collapse-item__wrap {
        border-bottom: 0;
    }

    .titulo-empresas {
        text-transform: capitalize;
    }

    .titulo-collapse {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
    }

    .label-soma {
        color: #19194b;
        font-size: 12px;
    }

    .el-radio {
        margin-top: 7px !important;
    }

    .grafico-box {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;

        .grafico-direito {
            width: 47%;
        }

        .grafico-esquerdo {
            width: 47%;
        }
    }
}
</style>
